import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router';
import type { PageFC } from '@salesforce/pwa-kit-react-sdk';
import { Layout } from '../../../components/layout/Layout';
import { Blocks } from '../../../components/sfcc-content-rendering/Blocks';
import { HtmlSnippet } from '../../../components/sfcc-content-rendering/HtmlSnippet';
import { useBreadcrumbs } from '../../../ui-components/breadcrumbs/useBreadcrumbs';
import { canonicalUrlCleanup } from '../../../utils/canonical-url-cleanup';
import { BreadcrumbSchema } from '../../../utils/schema';
import { SearchHead } from '../../search/SearchHead';
import type { CategoryInfo } from '../api/getContentData';

type Props = {
    categoryInfo?: CategoryInfo;
};

const ShowCatLanding: PageFC<Props> = ({ categoryInfo }: Props) => {
    const category = categoryInfo?.response?.category;
    const breadcrumbs = useBreadcrumbs(category?.parentCategoryTree);
    const location = useLocation();
    return (
        <Layout>
            <SearchHead canonicalUrl={canonicalUrlCleanup(location.pathname)} />
            <Box width="100%">
                <BreadcrumbSchema breadcrumbTrail={breadcrumbs} />
                <div className="shop-by-category">
                    <div className="pt_categorylanding">
                        <div className="brand-category-landing">
                            <Blocks
                                id="cat-landing-slot-1"
                                contentBlocks={
                                    categoryInfo?.response?.categoryContent?.categorySlots
                                }
                            />

                            <div id="secondary" className="refinements">
                                <h1 className="refinement-header h2">
                                    {category?.c_h1TagValue
                                        ? category.c_h1TagValue
                                        : category?.name}
                                </h1>
                            </div>

                            <div className="primary-content dinnerware-collections-class">
                                <div id="primary">
                                    <Blocks
                                        id="cat-landing-slot-2"
                                        contentBlocks={
                                            categoryInfo?.response?.categoryContent?.categorySlots
                                        }
                                    />
                                    <Blocks
                                        id="cat-landing-slot-3"
                                        contentBlocks={
                                            categoryInfo?.response?.categoryContent?.globalSlots
                                        }
                                    />
                                    {categoryInfo?.response?.category?.name ===
                                    'Dinnerware Collections' ? (
                                        <div className="dinnerware-collections-container">
                                            <Blocks
                                                id="dinnerware-collection-slot-1"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-2"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-3"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-4"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-5"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-6"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-7"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-8"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-9"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-10"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-11"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-12"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-13"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-14"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-15"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                            <Blocks
                                                id="dinnerware-collection-slot-16"
                                                contentBlocks={
                                                    categoryInfo?.response?.categoryContent
                                                        ?.globalSlots
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <Blocks
                                            id="cat-landing-slot-4"
                                            contentBlocks={
                                                categoryInfo?.response?.categoryContent
                                                    ?.categorySlots
                                            }
                                        />
                                    )}
                                    <Blocks
                                        id="cat-landing-slot-5"
                                        contentBlocks={
                                            categoryInfo?.response?.categoryContent?.categorySlots
                                        }
                                    />
                                    <div className="secondary-content">
                                        <div className="clp-border-width">
                                            <div className="border-tablet-mobile" />
                                        </div>
                                        <Blocks
                                            id="cat-landing-slot-6"
                                            contentBlocks={
                                                categoryInfo?.response?.categoryContent
                                                    ?.categorySlots
                                            }
                                        />
                                        <Blocks
                                            id="cat-landing-promo-messaging-asset"
                                            contentBlocks={
                                                categoryInfo?.response?.categoryContent
                                                    ?.contentAssets
                                            }
                                        />
                                    </div>
                                    <Blocks
                                        id="cat-landing-bottom-block"
                                        contentBlocks={
                                            categoryInfo?.response?.categoryContent?.categorySlots
                                        }
                                    />
                                    <Blocks
                                        id="seo-content-block-js-css"
                                        contentBlocks={
                                            categoryInfo?.response?.categoryContent?.contentAssets
                                        }
                                    />
                                    <HtmlSnippet
                                        html={categoryInfo?.response?.category?.c_seo ?? ''}
                                        id="seo-content"
                                    />
                                </div>
                            </div>
                            <div className="clear" />
                        </div>
                    </div>
                </div>
            </Box>
        </Layout>
    );
};

ShowCatLanding.defaultProps = {
    categoryInfo: undefined,
};

export { ShowCatLanding };
